import Qs from 'qs';
import instance from './client';

export const fetchFAQs = ({
  filter,
  headers,
}: {
  filter?: any;
  headers?: any;
}) => {
  return instance.get('/v1/customer/faqs', {
    params: filter,
    paramsSerializer(params) {
      return Qs.stringify(params, { arrayFormat: 'brackets' });
    },
    headers: headers,
  });
};
